import VideoPlayer from "./VideoPlayer";
import "../style/video-presentation.css";

export default function VideoPresentation({ video, autoplay }) {
    const extension = video.fileName.split(".")[1];

    return (
        <>
            <div className="video-presentation">
                <VideoPlayer video={video} extension={extension} autoplay={autoplay} />
                <div className="bottom-block video-description-block">
                    <div className="video-name">
                        {video.name}
                    </div>
                    {video.description.map((descriptionBlock, index) => (
                        <div key={index}>
                            {descriptionBlock}
                        </div>
                    ))}
                </div>
            </div>
            <div className="bottom-block caption">
                <span className="caption-video-name">{video.name}</span>,&nbsp;
                <span>{video.caption}</span>
            </div>
        </>
    );
}
